import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import star from "../../images/star.svg";
import star_fallback from "../../images/star_fallback.png";
import { THEME_COLOR } from "../../styles/colors";

/**
 * Shared "Transcribe meeting" card frame: outline box + star icon + title.
 * TranscribeAvailable and TranscribeNotAvailable each drop this into their own
 * outer layout with different contents:
 *
 * - `badge`    — under the title, in the star's right column
 *                (TranscribeNotAvailable's "Not available" alert).
 * - `children` — below the star+title row, full inner width
 *                (TranscribeAvailable's Transcribe/End button + modals).
 */
const TranscribeBox = ({ badge, children }) => (
  <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY }}>
    <Box type="outline" width="226px" height="100px" spacingInset="400">
      <Column spacing="400">
        <Row spacing="400" alignmentVertical="top">
          <img
            src={star}
            alt="star"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = star_fallback;
            }}
          />
          <Column spacing="400">
            <Text type="h50" alignment="start">
              Transcribe meeting
            </Text>
            {badge}
          </Column>
        </Row>
        {children}
      </Column>
    </Box>
  </Theme>
);

export default TranscribeBox;
